import Vue from 'vue'
import Router from 'vue-router'
import auth from "../assets/js/auth";

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        {path: '/:companyId/dct_show', component: require('@/components/discount/show').default, meta: {title: '优惠活动'}},
        {path: '/:companyId/dct_my', component: require('@/components/discount/my').default, meta: {title: '优惠券'}},
        {path: '/:companyId/inte_store', component: require('@/components/inte_store/inte_store').default, meta: {title: '积分兑换'}},
        {path: '/:companyId/gift', component: require('@/components/gift/index').default, meta: {title: '礼品券'}},
        {path: '/:companyId/store_details', component: require('@/components/inte_store/store_details').default, meta: {title: '商品详情'}},
        {path: '/:companyId/mall_buy', component: require('@/components/inte_store/mall_buy').default, meta: {title: '兑换商品'}},
        {path: '/:companyId/stay_list', component: require('@/components/stay/stay_list').default, meta: {title: '待评论'}},
        {path: '/:companyId/comments', component: require('@/components/stay/comments').default, meta: {title: '评论'}},
        {path: '/:companyId/evaluation_admin', component: require('@/components/stay/evaluation_admin').default, meta: {title: '评价管理'}},
        // 我的服务
        {path: '/:companyId/oiling', component: require('@/components/oiling/oiling').default, meta: {title: '一键加油'}},
        {path: '/:companyId/my', component: require('@/components/my/my').default, meta: {title: '个人中心'}},
        {
            path: '/:companyId/index',
            name: 'Index',
            component: require('../pages/Index').default,
            meta: {
                title: '首页'
            }
        },
        {
            path: '/:companyId/banner',
            name: 'Banner',
            component: require('../pages/common/Banner').default,
            meta: {
                title: '广告详情'
            }
        },
        {
            path: '/:companyId/notice',
            name: 'Notice',
            component: require('../pages/common/Notice').default,
            meta: {
                title: '公告详情'
            }
        },
        {
            path: '/:companyId/common/not_open',
            name: 'NotOpen',
            component: require('../pages/common/NotOpen').default,
            meta: {
                title: '暂未开放',
            }
        },
        // 卡片
        {
            path: '/:companyId/card/index',
            name: 'Card',
            component: require('../pages/card/Index').default,
            meta: {
                title: '油卡管理'
            }
        },
        {
            path: '/:companyId/card/handle',
            name: 'CardHandle',
            component: require('../pages/card/Handle').default,
            meta: {
                title: '油卡办理'
            }
        },
        {
            path: '/:companyId/card/binding',
            name: 'Binding',
            component: require('../pages/card/Binding').default,
            meta: {
                title: '绑定油卡'
            }
        },
        {
            path: '/:companyId/card/recharge',
            name: 'Recharge',
            component: require('../pages/card/Recharge').default,
            meta: {
                title: '油卡充值'
            }
        },
        {
            path: '/:companyId/card/consume_log',
            name: 'ConsumeLog',
            component: require('../pages/card/ConsumeLog').default,
            meta: {
                title: '消费记录'
            }
        },
        {
            path: '/:companyId/card/integral_log',
            name: 'IntegralLog',
            component: require('../pages/card/IntegralLog').default,
            meta: {
                title: '积分记录'
            }
        },
        // 加油
        /* {
            path: '/:companyId/oiling/index',
            name: 'Oiling',
            component: require('../pages/oiling/Index').default,
            meta: {
                title: '一键加油'
            }
        }, */
        {
            path: '/:companyId/oiling/index',
            name: 'Oiling',
            component: require('../pages/oiling2/Index').default,
            meta: {
                title: '一键加油'
            }
        },
        {
            path: '/:companyId/oiling/order',
            name: 'OilingOrder',
            component: require('../pages/oiling/Order').default,
            meta: {
                title: '确认订单'
            }
        },
        // 站点
        {
            path: '/:companyId/site/index',
            name: 'SiteIndex',
            component: require('../pages/site/Index').default,
            meta: {
                title: '附近油站'
            }
        },
        {
            path: '/:companyId/site/detail',
            name: 'SiteDetail',
            component: require('../pages/site/Detail').default,
            meta: {
                title: '站点详情'
            }
        },
        // 个人中心
        {
            path: '/:companyId/user/index',
            name: 'User',
            component: require('../pages/user/Index').default,
            meta: {
                title: '个人中心'
            }
        },
        {
            path: '/:companyId/user/info',
            name: 'UserInfo',
            component: require('../pages/user/Info').default,
            meta: {
                title: '个人中心信息'
            }
        },
        {
            path: '/:companyId/user/modify_payment_password',
            name: 'ModifyPaymentPassword',
            component: require('../pages/user/ModifyPaymentPassword').default,
            meta: {
                title: '修改支付密码'
            }
        },
        {
            path: '/:companyId/user/forget_payment_password',
            name: 'ForgetPaymentPassword',
            component: require('../pages/user/ForgetPaymentPassword').default,
            meta: {
                title: '忘记支付密码'
            }
        },
        // 订单
        {
            path: '/:companyId/order/recharge',
            name: 'RechargeOrder',
            component: require('../pages/order/RechargeOrder').default,
            meta: {
                title: '充值订单'
            }
        },
        {
            path: '/:companyId/order/consume',
            name: 'ConsumeOrder',
            component: require('../pages/order/ConsumeOrder').default,
            meta: {
                title: '消费订单'
            }
        },
        {
            path: '/:companyId/order/integral',
            name: 'IntegralOrder',
            component: require('../pages/order/IntegralOrder').default,
            meta: {
                title: '积分兑换订单'
            }
        },
        // 订单详情
        {
            path: '/:companyId/order/recharge/detail',
            name: 'RechargeDetail',
            component: require('../pages/order/RechargeDetail').default,
            meta: {
                title: '充值详情'
            }
        },
        {
            path: '/:companyId/order/consume/detail',
            name: 'ConsumeDetail',
            component: require('../pages/order/ConsumeDetail').default,
            meta: {
                title: '消费详情'
            }
        },
        {
            path: '/:companyId/order/integral_detail',
            name: 'IntegralOrderDetail',
            component: require('../pages/order/IntegralOrderDetail').default,
            meta: {
                title: '积分兑换详情'
            }
        },
        // 积分商城
        {
            path: '/:companyId/goods/index',
            name: 'IntegralGoods',
            component: require('../pages/goods/Index').default,
            meta: {
                title: '积分商城'
            }
        },
        {
            path: '/:companyId/goods/detail',
            name: 'IntegralGoodsDetail',
            component: require('../pages/goods/Detail').default,
            meta: {
                title: '商品详情'
            }
        },
        {
            path: '/:companyId/goods/checkout',
            name: 'IntegralGoodsCheckout',
            component: require('../pages/goods/Checkout').default,
            meta: {
                title: '商品结算'
            }
        },
        // 随手购
        {
            path: '/:companyId/goods/handy_purchase',
            name: 'HandyPurchase',
            component: require('../pages/goods/HandyPurchase').default,
            meta: {
                title: '随手购'
            }
        },
        // 优惠券
        {
            path: '/:companyId/coupon/index',
            name: 'CouponIndex',
            component: require('../pages/coupon/Index').default,
            meta: {
                title: '优惠券'
            }
        },
        // 兑换券
        {
            path: '/:companyId/exchange/index',
            name: 'ExchangeIndex',
            component: require('../pages/exchange/Index').default,
            meta: {
                title: '兑换券'
            }
        },
        {
            path: '/:companyId/exchange/detail',
            name: 'ExchangeDetail',
            component: require('../pages/exchange/Detail').default,
            meta: {
                title: '兑换券详情'
            }
        },
        {
            path: '/:companyId/activity/detail',
            name: 'ActivityDetail',
            component: require('../pages/activity/Detail').default,
            meta: {
                title: '活动详情'
            }
        },
        {
            path: '/:companyId/user/sms_login',
            name: 'SmsLogin',
            component: require('../pages/user/SmsLogin').default,
            meta: {
                title: '登录'
            }
        },
        {
            path: '/:companyId/user/modify_phone',
            name: 'ModifyPhone',
            component: require('../pages/user/ModifyPhone').default,
            meta: {
                title: '修改手机号'
            }
        },
        {
            path: '/:companyId/user/bind_phone',
            name: 'BindPhone',
            component: require('../pages/user/BindPhone').default,
            meta: {
                title: '绑定手机号'
            }
        },
        {
            path: '/:companyId/user/payment_code',
            name: 'PaymentCode',
            component: require('../pages/user/PaymentCode').default,
            meta: {
                title: '支付码'
            }
        },
        {
            path: '/:companyId/user/invite_code',
            name: 'InviteCode',
            component: require('../pages/user/InviteCode').default,
            meta: {
                title: '邀请有礼'
            }
        },
        {
            path: '/:companyId/user/certification',
            name: 'Certification',
            component: require('../pages/user/Certification').default,
            meta: {
                title: '车主认证'
            }
        },
        {
            path: '/:companyId/user/company_list',
            name: 'CompanyList',
            component: require('../pages/user/CompanyList').default,
            meta: {
                title: '公司认证'
            }
        },
        {
            path: '/:companyId/user/invite_consume',
            name: 'InviteConsume',
            component: require('../pages/user/InviteConsume').default,
            meta: {
                title: '邀请消费'
            }
        },
        {
            path: '/:companyId/company/company_detail/:certifiactionCompanyId',
            name: 'CompanyDetail',
            component: require('../pages/company/companyDetail').default,
            meta: {
                title: '公司详情'
            }
        },
        {
            path: '/:companyId/company/company_card_list',
            name: 'CompanyCardList',
            component: require('../pages/company/companyCardList').default,
            meta: {
                title: '公司卡片列表'
            }
        },
        {
            path: '/:companyId/company/company_card_invite',
            name: 'CompanyCardInvite',
            component: require('../pages/company/companyCardInvite').default,
            meta: {
                title: '卡片邀请'
            }
        },
        {
            path: '/:companyId/company/company_card_transfer',
            name: 'CompanyCardTransfer',
            component: require('../pages/company/companyCardTransfer').default,
            meta: {
                title: '卡片划拨'
            }
        },
        {
            path: '/:companyId/company/company_card_consume_log',
            name: 'CompanyCardConsumeLog',
            component: require('../pages/company/companyCardConsumeLog').default,
            meta: {
                title: '公司卡消费记录'
            }
        },
        {
            path: '/:companyId/card/company_card_integral_log',
            name: 'CompanyCardIntegralLog',
            component: require('../pages/company/companyCardIntegralLog').default,
            meta: {
                title: '公司卡积分记录'
            }
        },
        {
            path: '/:companyId/activity/spin_lottery',
            name: 'SpinLottery',
            component: require('../pages/activity/SpinLottery').default,
            meta: {
                title: '转盘抽奖'
            }
        },
        {
            path: '/:companyId/user/lottery_chance',
            name: 'LotteryChance',
            component: require('../pages/user/LotteryChance').default,
            meta: {
                title: '抽奖机会'
            }
        },
        {
            path: '/:companyId/invoice/invoice_title_info',
            name: 'InvoiceTitleInfo',
            component: require('../pages/invoice/InvoiceTitleInfo').default,
            meta: {
                title: '开票抬头信息'
            }
        },
        {
            path: '/:companyId/invoice/invoice_title_detail',
            name: 'InvoiceTitleDetail',
            component: require('../pages/invoice/InvoiceTitleDetail').default,
            meta: {
                title: '开票抬头详情'
            }
        },
        {
            path: '/:companyId/invoice/invoice_order_list',
            name: 'InvoiceOrderList',
            component: require('../pages/invoice/InvoiceOrderList').default,
            meta: {
                title: '电子发票'
            }
        },
        {
            path: '/:companyId/invoice/invoice',
            name: 'Invoice',
            component: require('../pages/invoice/Invoice').default,
            meta: {
                title: '开票'
            }
        },
        {
            path: '/:companyId/invoice/invoice_history',
            name: 'InvoiceHistory',
            component: require('../pages/invoice/InvoiceHistory').default,
            meta: {
                title: '开票历史'
            }
        },
        {
            path: '/:companyId/invoice/invoice_detail',
            name: 'InvoiceDetail',
            component: require('../pages/invoice/InvoiceDetail').default,
            meta: {
                title: '发票详情'
            }
        },
        {
            path: '/:companyId/card/secondary_card_user',
            name: 'SecondaryCardUserList',
            component: require('../pages/card/SecondaryCardUserList').default,
            meta: {
                title: '副卡管理'
            }
        },
        {
            path: '/:companyId/card/secondary_card_invite',
            name: 'SecondaryCardInvite',
            component: require('../pages/card/SecondaryCardInvite').default,
            meta: {
                title: '邀请加入'
            }
        },
        {
            path: '/:companyId/order/evaluate',
            name: 'Evaluate',
            component: require('../pages/order/Evaluate').default,
            meta: {
                title: '填写评论'
            }
        },
        {
            path: '/:companyId/order/show_evaluate',
            name: 'ShowEvaluate',
            component: require('../pages/order/ShowEvaluate').default,
            meta: {
                title: '查看评论'
            }
        },

   //      我的福利
        {path: '/dct_show', component: require('@/components/discount/show').default, meta: {title: '优惠活动'}},
        {path: '/dct_my', component: require('@/components/discount/my').default, meta: {title: '优惠券'}},
        {path: '/inte_store', component: require('@/components/inte_store/inte_store').default, meta: {title: '积分兑换'}},
        {path: '/gift', component: require('@/components/gift/index').default, meta: {title: '礼品券'}},
        {path: '/store_details', component: require('@/components/inte_store/store_details').default, meta: {title: '商品详情'}},
        {path: '/mall_buy', component: require('@/components/inte_store/mall_buy').default, meta: {title: '兑换商品'}},
        {path: '/stay_list', component: require('@/components/stay/stay_list').default, meta: {title: '待评论'}},
        {path: '/comments', component: require('@/components/stay/comments').default, meta: {title: '评论'}},
        {path: '/site_detail', component: require('@/components/site/site_details').default, meta: {title: '站点详情'}},
        {path: '/evaluation_admin', component: require('@/components/stay/evaluation_admin').default, meta: {title: '评价管理'}},
        // 我的服务
        {path: '/oiling', component: require('@/components/oiling/oiling').default, meta: {title: '一键加油'}},
        {path: '/site', component: require('@/components/site/site').default, meta: {title: '附近油站'}},
        {path: '/card', component: require('@/components/card/card').default, meta: {title: '油卡管理'}},
        {path: '/my', component: require('@/components/my/my').default, meta: {title: '个人中心'}},
    ]
})
// 路由过滤（路由卫士)
router.beforeEach((to, from, next) => {
    // 重定标题
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next();
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js